import { gql } from '@apollo/client';

export const GET_COMPANIES_FOR_SELECT = gql`
	query GetCompaniesForSelect(
		$page: Int!
		$limit: Int!
		$filters: CompanyFilterInput
	) {
		companies(
			filters: $filters
			pagination: { page: $page, limit: $limit }
		) {
			items {
				id
				gorkoId
				name
				isGroup
				groupLinksAsMember {
					unlinked
				}
				city {
					name
				}
			}
			pagination {
				currentPage
				totalPages
				totalCount
			}
		}
	}
`;
